import { Button, GenericError, Input } from "components";
import Spinner from "components/Spinner";
import React from "react";
import { ButtonRow } from "styles/elements/main";
import { FormGroup, FormStyle } from "styles/forms/main";

function LocationCategoryForm({
    locationCategoryData,
    handleLocationCategoryChange,
    onClose,
    handleLocationCategorySubmit,
    errors,
    errorList,
    nameArError,
    nameEnError,
    codeError,
    isLoading,
    buttonName,
}) {
    return (
        <FormStyle style={{ paddingBottom: "0rem" }}>
            <FormGroup>
                <Input
                    label="Location category Arabic Name"
                    placeholder="مستشفى"
                    type="text"
                    name="arabicName"
                    value={locationCategoryData?.arabicName}
                    onChange={(e) => handleLocationCategoryChange(e)}
                    errorMessage={errorList?.arabicName || nameArError}
                    required
                    isEditable
                />
            </FormGroup>
            <FormGroup>
                <Input
                    label="Location Category English Name"
                    placeholder="Hospital"
                    name="englishName"
                    type="text"
                    value={locationCategoryData?.englishName}
                    onChange={(e) => handleLocationCategoryChange(e)}
                    errorMessage={errorList?.englishName || nameEnError}
                    required
                    isEditable
                />
            </FormGroup>
            <FormGroup>
                <Input
                    label="Location Category Code"
                    placeholder="Ex: HSP"
                    type="text"
                    name="code"
                    value={locationCategoryData?.code}
                    onChange={(e) => handleLocationCategoryChange(e)}
                    errorMessage={errorList?.code || codeError}
                    required
                    isEditable
                />
            </FormGroup>
            {errors && <GenericError errorMassege={errors} />}

            <ButtonRow style={{ paddingBottom: "2rem" }}>
                <Button
                    type="button"
                    onChange={onClose}
                    name="Cancel"
                    btnStyle="secondBtn"
                />
                <Button
                    type="submit"
                    onChange={handleLocationCategorySubmit}
                    name={isLoading ? <Spinner /> : buttonName}
                    btnStyle="primaryBtn"
                />
            </ButtonRow>
        </FormStyle>
    );
}

export default LocationCategoryForm;
